export default {
    appShell: {
    "menuLabels": [
        "行情工具",
        "合约工具",
        "链上探索",
        "资讯分类"
    ],
    "closeMenu": "关闭菜单",
    "menuDescriptions": {
        "collect": "追踪你收藏的币种",
        "platform": "查看交易所排名与成交量",
        "toolOutsidePrice": "比较场外交易价格",
        "toolOutsideDisk": "观察全球市场走势",
        "toolSentimentIndex": "查看恐慌与贪婪指数",
        "manyEmpty": "比较多空持仓与交易比例",
        "hyperliquid": "监控 Hyperliquid 巨鲸持仓",
        "rate": "比较各交易所资金费率",
        "toolLargeIncrease": "追踪大户增加持仓",
        "toolLargeDecrease": "追踪大户减少持仓",
        "newChain": "探索新上线的代币",
        "whale": "查看巨鲸与机构持仓",
        "trace": "追踪收藏地址的动向",
        "inscription": "探索铭文市场数据",
        "toolStableCoin": "供应量、溢价与发行趋势",
        "toolCompanyHoldings": "查看企业 BTC 持仓",
        "toolMTGoxMonitor": "追踪 Mt. Gox 钱包转出",
        "toolBlockChainBrowser": "前往各链的区块浏览器",
        "calendar": "查看重要经济事件与日程",
        "forum": "浏览社区文章与讨论",
        "application": "探索市场相关应用与资源"
    }
,
    "back": "返回",
    "switchPage": "切换页面",
    "collapse": "收起",
    "intro": "行情、情绪与资金动向。",
    "home": "TokenTrend 首页",
    "externalLink": "外部网站",
    "openExternal": "打开网站",
    "externalBridgeHint": "即将离开 TokenTrend，前往外部网站。打开后可从屏幕左缘往右滑返回。",
    "light": "切换浅色模式",
    "dark": "切换深色模式",
    "search": "搜索币种",
    "closeSearch": "关闭搜索",
    "brandTagline": "行情 · 情绪 · 资金",
    "greetingMorning": "早上好，",
    "greetingAfternoon": "下午好，",
    "greetingEvening": "晚上好，",
    "darkModeLabel": "深色模式",
    "appearance": "外观",
    "themeLight": "浅色",
    "themeDark": "深色",
    "notifications": "通知",
    "closeNotifications": "关闭通知",
    "notifySample": [
        { "title": "比特币守住 77,000 美元", "body": "隔夜盘后 BTC 维持稳健。" },
        { "title": "资金费率大致平衡", "body": "主要交易所仍接近中性。" },
        { "title": "市场情绪中性", "body": "恐慌贪婪指数仍在区间中段。" }
    ],
    "workspace": "市场工作空间",
    "categories": "页面分类",
    "navigation": "主要导航",
    "groups": [
        "行情",
        "合约",
        "链上",
        "资讯",
        "我的"
    ],
    "pages": {
        "market": "市场行情",
        "platform": "交易平台",
        "manyEmpty": "多空分析",
        "hyperliquid": "Hyperliquid巨鲸监控",
        "hyperliquidDetails": "Hyperliquid持仓",
        "whale": "巨鲸与持仓",
        "burst": "爆仓数据",
        "calendar": "经济日历",
        "burstHeatmapDetails": "爆仓热力图",
        "burstCoinStatisticsDetails": "币种爆仓统计",
        "rate": "资金费率",
        "application": "应用资源",
        "publicChain": "公链数据",
        "newChain": "新币",
        "inscription": "铭文",
        "consult": "资讯",
        "solswap": "代币兑换",
        "my": "账户中心",
        "signIn": "每日签到",
        "contractCheck": "合约检查",
        "userHitNewRobotInfo": "代币交易信息",
        "calendarDetail": "经济事件详情",
        "consultDetails": "文章详情",
        "newCoinDetails": "新币详情",
        "firmOffer": "实盘交易"
    }
},
    common: {
        empty: '暂无数据',
        listLoading: '加载中...',
        listNoMore: '没有更多了',
        tenThousand: "万",
        hundredMillion: "亿",
        copy: '复制',
        copySuccess: '复制成功！',
        sendSuccess: '发送成功！',
        confirmText: '确认',
        cancelText: '取消',
        contact: '联系我们',
        privacy: "隐私政策",
    },
    contact: {
        title: '联系我们',
        info1: 'TokenTrend',
        info2: '邮箱:',
    },
    homeNav: {
        market: '行情',
        platform: '平台',
        manyEmpty: '多空',
        whale: '巨鲸',
        burst: '爆仓',
        rate: '费率',
        calendar: '日历',
        inscription: '铭文',
        application: '应用',
        searchPlaceholder: '地址或币种查询',
        searchTitle1: '合约',
        searchTitle2: '币种',
        searchList1: '链上交易额',
        searchList2: '流通数量',
        searchNoResult: '暂无搜索结果',
        historyTitle: '历史搜索记录'
    },
    calendar: {
        title: '日历',
        tit1: '只看重要',
        tit2: '经济数据',
        tit3: '事件',
        week0: '周日',
        week1: '周一',
        week2: '周二',
        week3: '周三',
        week4: '周四',
        week5: '周五',
        week6: '周六',
        tab1: '数据/时间',
        tab2: '前值/预测',
        tab3: '重要性/公布',
        event1: '国家/时间',
        event2: '事件/重要性',
    },
    calendar_details: {
        label1: '最新发布',
        label2: '公布值',
        label3: '预测值',
        label4: '前值',
        label5: '下次公布时间',
        label6: '发布频率',
        label7: '重要性',
        label8: '数据释义',
        label9: '数据影响',
        label10: '统计方法',
        label11: '公布机构',
        label12: '历史数据',
        label13: '1年',
        label14: '2年',
        label15: '5年',

"title": "经济日历详情"
},
    footerNav: {
        publicChain: '公链',
        newChain: '打新',
        inscription: '铭文',
        consult: '新闻',
        calendar: '非农日历',
        my: '我的',

"smartMoney": "聪明钱"
},
    login: {
        title: '登 录',
        enterUserName: '请输入电子邮箱/用户名',
        enterPassword: '请输入密码',
        enterLogin: '登录',
        loginTip: '登录中...',
        forgotPassword: '忘记密码',
        register: '注册账号',
    },
    register: {
        title: '注 册',
        enterUserName: '用户名',
        enterPassword: '密码',
        enterEmail: '电子邮箱',
        enterCode: '邮箱验证码',
        inviteCode: '邀请码（可选）',
        sendEmailCode: '发送验证码',
        enterUserNameErr: '请输入用户名',
        enterUserNameErr2: '用户名由6～16位字母或数字组成',
        enterPasswordErr: '请输入密码',
        enterPasswordErr2: '密码由8~18位英文字母、数字、特殊符号组成',
        enterEmailErr: '请输入电子邮箱',
        enterEmailErr2: '请输入正确的电子邮箱',
        enterCodeErr: '请输入邮箱验证码',
        enterRegister: '注册',
        registerSuccess: '注册成功，即将跳转登录页面...',
        toLogin: '已有账号？直接登录',
        emailCodeTip: '如果您在收件箱中未收到邮件，那可能是被误判为垃圾邮件了，请去邮箱垃圾箱中查看。'
    },
    userDelete: {
        title: '删除账号',
        enterUserName: '用户名',
        enterPassword: '密码',
        enterEmail: '电子邮箱',
        enterCode: '邮箱验证码',
        sendEmailCode: '发送验证码',
        enterUserNameErr: '请输入用户名',
        enterPasswordErr: '请输入密码',
        enterEmailErr: '请输入电子邮箱',
        enterCodeErr: '请输入邮箱验证码',
        enterRegister: '确认删除',
        registerSuccess: '删除成功，即将跳转登录页面...',
    },
    forgotPassword: {
        title: '忘 记 密 码',
        enterEmail: '电子邮箱',
        enterCode: '邮箱验证码',
        sendEmailCode: '发送验证码',
        enterEmailErr: '请输入电子邮箱',
        enterEmailErr2: '请输入正确的电子邮箱',
        enterCodeErr: '请输入邮箱验证码',
        enterPassword: '新密码',
        enterPasswordErr: '请输入新密码',
        enterPasswordErr2: '密码由8~18位英文字母、数字、特殊符号组成',
        enterBtn1: '取消',
        enterBtn2: '确认',
        forgotPasswordSuccess: '修改成功，即将跳转登录页面...'
    },
    coinDetails: {
        title: '币种详情',
        tab1: '交易数据',
        tab2: '币种信息',
        topInfo1: '24H涨跌幅',
        topInfo2: '24H最高价',
        topInfo3: '24H最低价',
        topInfo4: '交易量',
        topInfo5: '24H成交额',
        topInfo6: '24H开盘价',
        topInfo7: '历史最低价',
        bottomInfo1: '币种',
        bottomInfo2: '币种全称',
        bottomInfo3: '官网链接',
        bottomInfo4: '历史最高价格',
        bottomInfo5: '历史最低价格',
        bottomInfo6: '流通量',
        bottomInfo7: '发行总量',
        bottomInfo8: '最大供应量',
        bottomInfo9: '上市时间',
        bottomInfo10: 'Telegram',
        bottomInfo11: '白皮书链接',
        bottomInfo12: '热度排名',
        bottomInfo13: '市值排名',

"trade_txt1": "资金流向分析",
"trade_txt2": "持仓分析",
"trade_txt3": "多空比例",
"trade_txt4": "大户持仓",
"trade_txt5": "大户流动性",
"trade_txt6": "大户交易",
"trade_txt7": "大户持仓分布"
},
    coinTrade: {
        title1: '资金流向分析',
        title2: '24小时资金净流入',
        title3: '5 日主力净流入:',
        title4: '杠杆借贷存量増速',
        title5: '杠杆多空比',
        title6: '逐仓借贷比',
        tableTh11: '订单',
        tableTh12: '买入',
        tableTh13: '卖出',
        tableTh14: '净流入',
        tableTh15: '大单',
        tableTh16: '中单',
        tableTh17: '小单',
        tableTh18: '总计',
        chart11: '大单买入',
        chart12: '中单买入',
        chart13: '小单买入',
        chart14: '大单卖出',
        chart15: '中单卖出',
        chart16: '小单卖出',
    },
    insdetail: {
        title: '铭文详情',
        topInfo1: '市值',
        topInfo2: '总交易额',
        topInfo3: '24H交易额',
        topInfo4: '持有人数',
        topInfo5: '成交比数',
        topInfo6: '在内存池',
        topInfo7: '进度',
        bottomInfo1: '名称',
        bottomInfo2: '总供应量',
        bottomInfo3: '部署铭文 ID',
        bottomInfo4: '编号',
        bottomInfo5: '单次铸造上限',
        bottomInfo6: '创建者',
        bottomInfo7: '结尾铭刻编号',
        bottomInfo8: '精度',
        bottomInfo9: '创建时间',
        tab1: '交易历史',
        tab2: '总览',
        cycle1: '24 小时',
        cycle2: '7 天',
        cycle3: '30 天',
    },
    swap: {
        title: '兑换',
        pay: '支付',
        receive: '预计收到',
        reverse: '切换兑换方向',
        title1: '交换',
        title2: '连接钱包',
        title3: '断开连接',
        title4: '返回',
        title5: '滑点',
        title6: '预估网络费',
        title7: '交换',
        title8: '余额不足',
        title9: '参考汇率',
        msg1: '钱包已连接',
        msg2: '钱包已断开',
        msg3: '请输入有效的金额',
        msg4: '请先连接钱包',
        msg5: '请打开 OKX 钱包以签署交易',
        msg6: '兑换成功完成！',
    },
    newCoinDetails: {
        topInfo1: '流通量',
        topInfo2: '流通率',
        topInfo3: '发售数量',
        topInfo4: '发行总量',
        topInfo5: '24小时涨幅',
        topInfo6: '最新价格',
        topInfo7: '发售价格',
        topInfo8: '预售时间',
        topInfo9: '上币平台',
        topInfo10: '发售占比',
        topInfo11: '直达链接',
        listTitle: '市场行情',
        list1: '交易平台',
        list2: '币对',
        list3: '24H交易量',
        list4: '24H交易额($)',
        list5: '占比',

"title": "新币详情"
},
    platformDetails: {
        title: '平台详情',
        volumn24h: '24H交易额',
        title1: '简介',
        content1: '成立时间：',
        content2: '注册地：',
        content3: 'KYC认证',
        content4: '量化接口',
        content5: '资产',
        content6: '交易对数量',
        content7: '官网',
        isTrue: '是',
        isFalse: '否',
        title2: '交易支持',
        content8: '现货交易',
        content9: '合约交易',
        content10: '场外交易',
        content11: '法币交易',
        title3: '相关链接',
        content12: 'Facebook',
        content13: 'Twitter',
        content14: 'Reddit',
        content15: 'Telegram',
    },
    topHome: {
        marketSentiment: '市场情绪',
        sentimentDetails: '查看详情',
        sentimentUnavailable: '暂无数据',
        sentimentIndexBlock1: '情绪指数',
        sentimentIndexBlock1_1: '极度恐慌',
        sentimentIndexBlock1_2: '恐慌',
        sentimentIndexBlock1_3: '中性',
        sentimentIndexBlock1_4: '贪婪',
        sentimentIndexBlock1_5: '极度贪婪',
        sentimentIndexBlock2: 'BTC持仓多空',
        sentimentIndexBlock2_1: '看多优势',
        sentimentIndexBlock2_2: '看空优势',
    },
    market: {
        tabs1: '热门',
        tabs2: '涨幅',
        tabs3: '跌幅',
        tabs4: '新币',
        tabs5: '飙升',
        tabs6: '市值',
        tabs7: '成交额',
        popularTh1: '币种/24H交易量',
        popularTh2: '最新价/24H成交额',
        popularTh3: '24H涨幅',
        newCoinTh1: '币种/上市时间',
        newCoinTh2: '最新价/24H成交额',
        newCoinTh3: '24H涨幅/交易量',
        marketTh1: '币种/流通市值',
        marketTh2: '最新价/24H成交额',
        marketTh3: '24H涨幅/交易量',
    },
    platform: {
        tabs1: '全球交易所资产排行',
        exchangeTableTh1: '平台',
        exchangeTableTh2: '资产',
        exchangeTableTh3: '官网',
    },
    manyEmpty: {
        overviewHint: "从交易量、账户与持仓，观察多空力量的变化。",
        topTraders: "大户分析",
        latestRatio: "最新多空比",
        balanced: "多空平衡",
        longBias: "多方较多",
        shortBias: "空方较多",
        interval: "时间周期",
        chartView: "图表显示",
        shareView: "占比",
        loading: "加载中…",
        failed: "暂时无法加载",
        noData: "此条件暂无数据",
        retry: "重试",
        touchHint: "按住图表查看数据",

        title1: '成交量多空比',
        title2: '人数多空比',
        title3: '大户账户数多空比',
        title4: '大户持仓量多空比',
        progress1: '多头：',
        progress2: '空头：',
        tableTh1: '交易所',
        tableTh2: '多空比',
        tableTh3: '多头占比',
        tableTh4: '空头占比',
        msg1: '多空比',
        msg2: '做多',
        msg3: '做空',
        msg4: '人数多空比',
        msg5: '多仓人数比例',
        msg6: '空仓人数比例',
        msg7: '多空账户数比',
        msg8: '多仓账户数比',
        msg9: '空仓账户数比',
        msg10: '多空持仓比',
        msg11: '多仓持仓比',
        msg12: '空仓持仓比',
    },
    whale: {
        holdingsTitle: '灰度持仓列表',
        holdingsTitle2: '更新时间：',
        holdingsTh1: '持仓变化',
        holdingsTh1_1: '1天:',
        holdingsTh1_2: '7天:',
        holdingsTh1_3: '30天:',
        holdingsTh2: '溢价率',
        holdingsTh3: '持仓币种数量',
        holdingsTh4: '持仓价值',
        contractTitle: '合约总持仓',
        contractTh1: '交易所',
        contractTh2: '持仓价值($)',
        contractTh3: '持仓数量',
        contractTh4: '15分钟变化',
        contractTh5: '1天变化',
        exchangeTitle: '交易所余额清单',
        exchangeTh1: '交易所',
        exchangeTh2: '钱包数量',
        exchangeTh3: '24H变化',
        exchangeTh4: '7天变化',
        exchangeTh5: '30天变化',
        statistics1: '总市值',
        statistics2: '24小时交易量',
        statistics3: '24小时最高价',
        listRight1: '转出地址：',
        listRight2: '转入地址：',
        listRight3: '转账数量：',
    },
    autosearch: {
        msg: '搜索',
        msg1: '请输入关键词(交易所,币名称)',
        msg2: '清空',
        msg3: '没有更多数据',
        msg4: '未找到相关数据',
    },
    burst: {
    explorerView: "清算图表",
    explorerheatmap: "热力图",
    explorermap: "清算地图",
    explorerOtherLeverage: "其他杠杆",
    explorerCumulativeLong: "累计多头清算量",
    explorerCumulativeShort: "累计空头清算量",
    explorerClose: "收起",
    explorerExpand: "放大图表",
    explorerCoin: "币种",
    explorerScope: "交易所",
    explorerPair: "单一交易所",
    explorerAll: "全市场",
    explorerEstimate: "模型估算清算区",
    explorerPrice: "最新参考价",
    explorerAbove: "上方主要热区",
    explorerBelow: "下方主要热区",

        currentPrice: '当前价格：',
        liquidationTip1: '累计多单清算强度',
        liquidationTip2: '累计空单清算强度',
        liquidationTip3: '10x杠杆',
        liquidationTip4: '25x杠杆',
        liquidationTip5: '50x杠杆',
        liquidationTip6: '100x杠杆',
        heatmapTop: '综合Binance、Huobi、OKX三大交易所数据，{0}USDT爆仓最大点位在{1}附近，爆仓价值为{2}USDT，请注意资金风险',
        toBurstHeat: '详情',
        heatmapMaximum: '清算强度上限',
        heatmapMinimum: '下限',
        heatmapKLine1: 'k线',
        heatmapKLine2: '清算强度',
        heatmapTip1: '价格',
        heatmapTip2: '清算强度',
        kLineTip1: '开盘价',
        kLineTip2: '收盘价',
        kLineTip3: '最高价',
        kLineTip4: '最低价',
        noLogin: '登录后查看热力图，',
        toLogin: '去登录',
        topBlockH4: '1H爆仓',
        topBlockH41: '4H爆仓',
        topBlockH42: '12H爆仓',
        topBlockH43: '24H爆仓',
        topBlockP: '多单占比',
        rankingTitle: '最近24H，爆仓排行：',
        rankingTh1: '交易所',
        rankingTh2: '爆仓数量',
        rankingTh3: '爆仓USD',
        rankingTh4: '多单USD',
        rankingTh5: '空单USD',
        coinStatisticsH4: '各币种爆仓统计',
        coinStatisticsT1: '1H',
        coinStatisticsT2: '4H',
        coinStatisticsT3: '24H',
        exchangeProportionH4: '全网交易所爆仓占比',
        exchangeProportionT1: '4H',
        exchangeProportionT2: '12H',
        exchangeProportionT3: '24H',
        heatmapDetailsList1Top: '空',
        heatmapDetailsList1Bottom: '多',
        heatmapDetailsList1: '方向：',
        heatmapDetailsList2: '价格：',
        heatmapDetailsList3: '清算：',
        coinStatisticsDetailsTh1: '币种',
        coinStatisticsDetailsTh2: '多单爆仓',
        coinStatisticsDetailsTh3: '空单爆仓',
        coinStatisticsDetailsTh4: '时间',
    },
    rate: {
        title1: '资金费率',
        type1: '持仓加权',
        type2: '成交额加权',
        price: '价格',
        newTitle: '交易所当前资金费率列表',
        newTableTh1: '币种',
        newTableTd1: '预测费率',
        tableTh1Old: '交易所',
        tableTh2Old: '当前费率',
        tableTh3Old: '最高费率',
        tableTh4Old: '最低费率',
    },
    application: {
        leftNav1: '应用',
        leftNav2: '钱包',
        leftNav3: '社交',
        visit: '前往',
        empty: '暂无内容',
        download: '下载',
        register: '注册'
    },
    publicChain: {
        loadFailed: '加载失败，请重试',
        retry: '重试',

        tableTh1: '配对/市值',
        tableTh2: '价格/成交量',
        tableTh3: '涨幅/时间',
    },
    inscription: {
        typeAll: '全部',
        tableTh1: '序号',
        tableTh2: '代币名称',
        tableTh3: '持有人',
        tableTh4: '总交易次数',
        tableTh5: '价格',
    },
    smartMoney: {
        swipe1: '让聪明钱帮我们打工',
        swipe2_1: '专为币圈新手定制',
        swipe2_2: '助力散户把握机遇',
        listTip: '7x24H监控',
        list1Title: 'Top 100 高频交易',
        list1Msg: '8大公链综合收益/收益率排名前100',
        list2Title: '明星聪明钱',
        list2Msg: '全球知名人士/公链创始人/知名机构地址追踪',
        list3Title: '一级聪明钱',
        list3Msg: '一级市场收益率较高/较稳定的聪明钱',
        list4Title: '自定义聪明钱',
        list4Msg: '用户自行添加的追踪钱包地址',
    },
    smartMoneyTop100: {
        topTip: '综合各大DEX近30天分析数据。余额仅供参考！',
        amountUsd: '代币总胜率',
        floatProfit: '交易额',
        floatProfitPercent: '交易数',
        profit: '盈利',
        profitPercent: '盈利率',
        collectTo: '收藏',
        collectCancel: '取消收藏',
        noLogin: '登录后可查看追踪全球前100位收益最高的聪明钱，',
        toLogin: '去登录',
    },
    smartMoneyStar: {
        title: '明星聪明钱',
    },
    smartMoneyOneLevel: {
        title: '一级聪明钱',
    },
    smartMoneyCustom: {
        title: '自定义聪明钱',
        addName: '名称：',
        addNameRules: '请输入名称',
        addAddress: '地址：',
        addAddressRules: '请输入地址',
        addComment: '备注：',
        addConfirm: '确认',
        addSuccess: '添加成功！',
        delBtn: '删除',
        delSuccess: '删除成功！'
    },
    smartMoneyDetails: {
        queryTokenAll: '全部',
        return: '返回',
        dexAddress: '地址：',
        dexHash: '交易hash：',
        dexChainName: '链名称：',
        dexTransactionAmount: '交易价值：',
        dexTrackerIn: '转入合约：',
        dexTrackerOut: '转出合约：',
        dexTrackerType: '交易方向：',
        dexTrackerTypeCon: '{0}{1} 兑换为 {2}{3}',
        dexTransactionTime: '交易时间：',
        ordinaryHash: '交易hash：',
        ordinaryFrom: '发送者地址：',
        ordinaryTo: '接收者地址：',
        ordinarySymbol: '币种名称：',
        ordinaryAmount: '转账数量：',
        ordinaryTime: '时间：',
    },
    consult: {
        topNav1: '快讯',
        topNav2: '公告',
        topNav3: '新闻',
        detailsShare: '分享：',
        detailsTime: '时间'
    },
    my: {
        headPictureSuccess: '修改成功！',
        toSignIn: '去签到',
        wallet: '签到钱包余额',
        details: '详情',
        memberTitle: '会员中心',
        memberItem1: '合约检查',
        memberItem2: '提币',
        memberItem3: '在线客服',
        memberItem4: '邀请链接',
        installMetaMask: '请先安装 Metamask！',
        nav1: '收藏',
        nav2: '追踪',
        nav3: '团队',
        nav4: '论坛',
        nav5: '工具',
        nav6: '语言',
        nav7: "退出登录",
        nav8: '绑定API',
        nav9: '打新机器人',
        nav10: '删除账号',
        nav11: "退出登录",
    },
    signIn: {
        title: '已签到{0}天',
        btn: '立即签到',
        tip1: "浏览平台{0}分钟，即可领取签到奖励",
        tip2: '（您已浏览{0}分钟{1}秒）',
        success: '签到成功！',
        recordTitle: '签到记录',
        recordListContent: '时间：',
    },
    signInRecord: {
        title: '钱包明细',
        selectAll: '全部',
        typeSelect1: '签到奖励',
        typeSelect2: '直推奖励',
        typeSelect3: '团队奖励',
        typeSelect4: '申请提现扣除',
        typeSelect5: '系统驳回增加',
    },
    contractCheck: {
        riskAssessment: '风险评估',
        riskInspection: '风险检查',
        enterPlaceholder: '请输入合约地址',
        enterBtn: '检查',
        checkNFT1: ['无恶意NFT', '恶意NFT'],
        checkNFT2: ['未开源', '已开源'],
        checkNFT3: ['无代理合约', '有代理合约'],
        checkNFT4: ['未验证', '已验证'],
        checkNFT5: ['不是著名的、值得信赖的NFT', '著名的、值得信赖的NFT'],
        checkToken1: ['不具有修改最大交易金额或最大代币持仓的功能', '具有修改最大交易金额或最大代币持仓的功能'],
        checkToken2: ['所有权不可以收回', '所有权可以收回'],
        checkToken3: ['合约无隐藏所有者', '合约有隐藏所有者'],
        checkToken4: ['不具有限制单个地址最大交易量或最大持仓量的功能', '具有限制单个地址最大交易量或最大持仓量的功能'],
        checkToken5: ['令牌不是蜜罐', '令牌是蜜罐'],
        checkToken6: ['代币不可以在去中心化交易所交易', '代币可以在去中心化交易所交易'],
        checkToken7: ['合约没有能力铸造代币', '合约有能力铸造代币'],
        checkToken8: ['未开源', '已开源'],
        checkToken9: ['不是代理', '是代理'],
        checkToken10: ['合约所有者不可以更改代币持有者余额', '合约所有者可以更改代币持有者余额'],
        checkToken11: ['不可以为每个分配的地址设置不同的税率', '可以为每个分配的地址设置不同的税率'],
        checkToken12: ['合约不可以自毁', '合约可以自毁'],
        checkToken13: ['合约不具有交易冷却机制', '合约具有交易冷却机制'],
        checkToken14: ['不可以通过代币合约暂停交易', '可以通过代币合约暂停交易'],
        checkToken15: ['该代币不是著名且值得信赖的代币', '该代币是著名且值得信赖的代币'],
        botToken1: '所有者地址',
        botToken2: '所有者的余额',
        botToken3: '所有者持有代币的百分比',
        botToken4: '供应数量',
        botNFT1: '总交易量',
        botNFT2: '持有者数量',
        botNFT3: '最高价格',
        botNFT4: '24小时平均价格',
        botNFT5: '24小时最低价格',
    },
    withdrawal: {
        title: '提币',
        titleTip: '提款地址必须是TRON（TRC-20）链的钱包地址。填写其他链的钱包地址将导致永久丢失且无法恢复。',
        withdrawalAddress: '您的提款地址：',
        inputWithdrawalAddress: '请输入提款地址',
        number: '数量',
        inputNumber: '请输入数量',
        inputNumberErr: '余额不足',
        balance: '余额',
        actualReceipt: '实际到账：',
        gas: '手续费：',
        tip: '最低提取{0}USDT，提现手续费{1}%。',
        confirm: '确定',
        explain: '网络交易需要0-2小时，且网络确认不包括在内',
        submitSuccess: '提交成功'
    },
    withdrawalRecord: {
        title: '提币记录',
        list1: '地址：',
        list2: '网络：',
        list3: '币种：',
        list4: '数量：',
        list5: '手续费：',
        list6: '状态：',
        list7: '时间：',
        status0: '待审核',
        status1: '通过',
        status2: '驳回',
    },
    bindingApi: {
        title: '绑定API',
        tip: '交易所创建API要求必须绑定IP',
        listTitle: '绑定列表',
        unBindBtn: '解绑',
        availableBalance: '可用余额：',
        bindFrom1: '选择交易所:',
        bindFrom1Err: '请选择交易所',
        bindFrom2Err: '请输入Api key',
        bindFrom3Err: '请输入Secret key',
        bindFrom4Err: '请输入PassPhrase(OKX必填)',
        bindFrom5: '备注:',
        bindFrom5Err: '请输入备注',
        bindSuccess: '绑定成功',
        unBindSuccess: '解绑成功'
    },
    myAsset: {
        disconnect: '断开连接'
    },
    collect: {
        title: '收藏',
        amountUsd: '余额',
        floatProfit: '浮盈',
        floatProfitPercent: '浮盈率',
        profit: '盈利',
        profitPercent: '盈利率',
        cancel: '取消收藏',
        cancelSuccess: '取消成功！',
    },
    trace: {
        title: '追踪',
        list1: '公链名称：',
        list2: '代币名称：',
        list3: '地址：',
        listDel: '删除',
        listDelSuccess: '删除成功！',
    },
    team: {
        title: '团队',
        topInfo1: '直推人数',
        topInfo2: '团队人数',
        topInfoUnit: '人',
        tableTh1: '用户名',
        tableTh2: '注册时间',
        inviteCode: '邀请码',
        empty: '还没有直推成员。分享邀请链接即可加入团队。',
    },
    forum: {
        title: '论坛',
        toForumPublishNoLogin: '请先去登录，登录后可发布！',
        publishTitle: '发布论坛',
        publishContentPlaceholder: '请输入内容',
        publishSuccess: '发布成功！',
        publishConfirm: '发布',
        forumList1: '全文',
        detailsTitle: '论坛正文',
        detailsCommentTitle: '评论',
        detailsCommentInputPlaceholder: '请输入评论内容',
        detailsCommentInputSuccess: '发送成功！',
        detailsCommentInputBtn: '发送',
    },
    tool: {
        title: '工具',
        tool1: 'BTC公司持仓',
        tool2: '情绪指数',
        tool3: '门头沟监控',
        tool4: '场外价格',
        tool5: '外盘数据',
        tool6: '大户增仓',
        tool7: '大户减仓',
        tool8: '稳定币',
        tool9: '区块链浏览器',
    },
    toolCompanyHoldings: {
        title: 'BTC持仓机构',
        titleSub1: '全球公司BTC持仓数据',
        globalDataT1: 'BTC持仓公司',
        globalDataD1: '家',
        globalDataT2: '公司总持仓',
        globalDataD2: '近7日变化：',
        globalDataT3: '持仓总价值',
        globalDataD3: '近7日变化：',
        globalDataT4: '持仓占BTC总市值',
        globalDataD4: '7日前占比：',
        titleSub2: 'BTC持仓公司',
        listTh1_1: '持仓价值($)/',
        listTh1_2: '占BTC市值',
        listTh2_1: '持仓BTC/',
        listTh2_2: '近7日持仓变化',
        listTh3_1: '总持仓成本/',
        listTh3_2: '平均成本($)',
    },
    toolSentimentIndex: {
        title: '情绪指数',
        titleSub1: '恐慌与贪婪指数',
        titleSub1_1: 'BTC与重要主流币的恐慌与贪婪指数',
        gauge1: '极度恐慌',
        gauge2: '恐慌',
        gauge3: '中性',
        gauge4: '贪婪',
        gauge5: '极度贪婪',
        titleSub2: '历史指数',
    },
    toolMTGoxMonitor: {
        title: '门头沟监控',
        titleSub1: '门头沟(MTGox)BTC冷钱包',
        topLabel1: '原持有BTC总量',
        topLabel1Span: '原价值',
        topLabel2: '现剩余BTC总量',
        topLabel2Span: '现价值',
        topLabel3: '持有BTC变化量',
        titleSub2: 'BTC冷钱包链上转出记录',
        tableTh1: '交易时间',
        tableTh2: '冷钱包地址',
        tableTh3: '转账BTC数量',
    },
    toolOutsidePrice: {
        title: '场外价格',
        th1: '交易所',
        th2: '成交均价',
        th3: '溢价',
    },
    toolOutsideDisk: {
        title: '外盘数据',
        itemTitleSpan: '更新',
        itemTitle2: '开盘时间：',
        beijingTime: '北京时间',
        nextDay: '次日',
        itemInfo1: '昨收',
        itemInfo2: '今开',
        itemInfo3: '今日成交量',
        itemInfo4: '今日最高',
        itemInfo5: '今日最低',
        itemInfo6: '近一年最高',
        itemInfo7: '近一年最低',
        names: {
            BRENT: '布伦特原油',
            DJI: '道琼斯指数',
            HKHSI: '香港恒生指数',
            INX: '标普500指数',
            IXIC: '纳斯达克综合指数',
            N225: '日经225',
            SH000001: '上证指数',
            SH000300: '沪深300指数',
            WTI: 'WTI原油',
            XAU: '伦敦金（现货黄金）',
        },
    },
    toolLargeIncrease: {
        title: '大户增仓',
        tableTh1: '币种',
        tableTh2: '24H涨跌',
        tableTh3: '24H持仓占比',
        tableTh4: '周持仓占比',
        tableTh5: '月持仓占比',
        tableTh6: '全球指数($)',
        tableTh7: '前10持仓占比',
        tableTh8: '前20持仓占比',
        tableTh9: '前50持仓占比',
        tableTh10: '前100持仓占比',
    },
    toolLargeDecrease: {
        title: '大户减仓',
        tableTh1: '币种',
        tableTh2: '24H涨跌',
        tableTh3: '24H持仓占比',
        tableTh4: '周持仓占比',
        tableTh5: '月持仓占比',
        tableTh6: '全球指数($)',
        tableTh7: '前10持仓占比',
        tableTh8: '前20持仓占比',
        tableTh9: '前50持仓占比',
        tableTh10: '前100持仓占比',
    },
    toolStableCoin: {
        title: '稳定币',
        UsdTopInfo1: 'USDT场外均价',
        UsdTopInfo2: '美元汇率',
        UsdTopInfo3: 'USDT溢价率',
        UsdTitleSub1: 'USDT相关指数走势',
        UsdIndexQuery1: '7天',
        UsdIndexQuery2: '30天',
        UsdTitleSub2: 'USDT溢价相关走势',
        relatedTitleSub1: '稳定币概况',
        relatedTopTh1: '币种',
        relatedTopTh2: '场外均价(¥)/溢价率',
        relatedTopTh3: '当前流通量',
        relatedTitleSub2: '稳定币流通量',
        relatedQuery1: '30天',
        relatedQuery2: '近一年',
        relatedTitleSub3: '稳定币流通量占比',
        relatedTitleSub4: '稳定币链上发行',
        relatedBottomListH4_1: '增发',
        relatedBottomListH4_2: '销毁',
        relatedBottomListHash: '交易哈希：',
    },
    toolBlockChainBrowser: {
        title: '区块链浏览器',
    },
    firmOffer: {

        titleLabel0: '合约地址：',
        titleLabel1: '持币地址数',
        titleLabel2: '独立交易地址数',
        titleLabel3: '交易笔数',
        titleLabel4: '成交额',
        titleLabel5: '流动性',
        titleLabel6: '总市值',
        titleLabel7: '创建时间',
        titleLabel8: '总锁仓市值',
        tabs1: '交易历史',
        tabs2: '池子变化',
        tabs3: '持币地址',
        tabs4: '资金',
        transactionTh1: '时间',
        transactionTh2: '价格($)',
        transactionTh3: '成交量($)',
        transactionTh4: '数量',
        transactionTh5: '钱包地址',
        transactionAddTrace: '确定跟踪此钱包地址吗? ',
        transactionAddTraceSuccess: '添加成功! ',
        tag1: '买 入',
        tag2: '卖 出',
        tag3: '增加',
        tag4: '减少',
        poolTip: '默认显示第一个池子数据',
        poolTh1: '时间',
        poolTh2: '类型',
        poolTh3: '成交量($)',
        poolTh4: '数量',
        poolTh5: '钱包地址',
        poolCurrent: '总地址数',
        Explain1: '总地址数:',
        Explain2: '前10占比:',
        Explain3: '狙击手数:',
        Explain4: '可疑持币地址数:',
        positionTh1: '排名',
        positionTh2: '钱包地址',
        positionTh3: '持有比例',
        positionTh4: '数量',
        positionTh5: '24小时变化',
        positionTh6: '区块信息',
        financeType1: 'Top 买家',
        financeType2: 'Top 卖家',
        financeTh1buy: '净买入',
        financeTh1sell: '净卖出',
        financeTh2buy: '买入金额($)',
        financeTh2sell: '卖出金额($)',
        financeTh3: '用户',
        addTrace: '确认追踪当前地址吗？',
        addTraceSuccess: '添加成功！',

"title": "代币详情"
},
    smartMoneySmall: {
        cycle1: '1分',
        cycle2: '5分',
        cycle3: '30分',
        cycle4: '1时',
        cycle5: '4时',
        cycle6: '1天',
        klineIndicator1: '买入',
        klineIndicator2: '卖出',
        tableTh1: '购买数量',
        tableTh2: '购买金额',
        tableTh3: '卖出数量',
        tableTh4: '卖出金额',
        tableTh5: '浮盈',
        tableThAddress: '地址：',
        detailsReturn: '返回列表',
        detailsAddress: '地址：',
        detailsTokenAddress: '代币地址：',
        detailsChainName: '链名称：',
        detailsTrackerType: '交易方向：',
        detailsTrackerTypeVal1: '买入',
        detailsTrackerTypeVal2: '卖出',
        detailsAmount: '购买数量：',
        detailsAmountUsd: '购买金额USD：',
        detailsTransactionTime: '交易时间：',
        detailsHash: '交易hash：',
    },
    hitNewRobot: {
        title: '打新机器人',
        topImg1: '智慧时代，领创科技未来',
        topImg2: '打新机器人',
        topImg3: '9月30日',
        topImg4: '正式上线',
        topImg5: '查看规则>>',
        type1: '交易所打新列表',
        hitNewlistTh1: '代币信息',
        hitNewlistTh2: '代币价格',
        hitNewlistTh3: '池',
        hitNewlistTh4: '初始/剩余',
        hitNewlistTh5: '时间',
        createBtn: '创建',
        createTitle: '创建机器人',
        createLabel1: '交易所名称：',
        createLabel2: '币对所名称：',
        createLabel3: '上币时间：',
        createLabel7: '可用余额：',
        createLabel4: '预计购买数量：',
        createLabel5: '预计购买价格：',
        createLabel6: '抢购时间：',
        createLabel4Err: '请输入预计购买数量',
        createLabel5Err: '请输入预计购买价格',
        createLabel6Err: '请选择抢购时间',
        createLabel6Select1: '选择年月日',
        createLabel6Select2: '选择时分秒',
        createTip: '购买价值必须>=10USDT',
        createSuccess: '创建成功！',
        type2: '机器人列表',
        robotListStatus1: '待执行',
        robotListStatus2: '已结束',
        robotListBinanceStatus1: '挂单成功',
        robotListBinanceStatus2: '挂单失败',
        robotList1: '执行时间：',
        robotList2: '取消机器人',
        robotList3: '币对',
        robotList4: '价格',
        robotList5: '数量',
        robotCancel: '取消成功',
    },
    hitNewRobotInfo: {
        title: '交易',
        title2: '交易历史'
    },
    hitNewRobotRule: {
        title: '数字货币打新机器人模块介绍',
        h2_1: '核心优势：',
        label1_1: '高效算法：',
        label1_2: '深度整合：',
        label1_3: '大数据处理：',
        label1_4: '智能策略：',
        label1_5: '安全保障：',
        label1_6: '自动化交易：',
        label1_7: '优化体验：',
        p1_1: '内置高效算法，毫秒级交易决策，精准捕捉市场动态。',
        p1_2: '整合Binance、HTX、OKX等主流交易所API，确保数据全面准确。',
        p1_3: '利用Apache Kafka与Flink技术，实时收集并处理市场数据。',
        p1_4: '结合TensorFlow或PyTorch框架，利用历史数据与趋势优化打新策略。',
        p1_5: '分布式架构，多重加密技术，保障用户数据与交易安全。',
        p1_6: '未来探索智能合约与跨链技术，实现DEX自动化交易与高效资产管理。',
        p1_7: '持续优化界面与交互设计，提供直观数据可视化工具，提升用户体验。',
        h2_2: '会员升级标准：',
        label2_1: 'v0 → v1：',
        label2_2: 'v1 → v2：',
        label2_3: 'v2 → v3：',
        label2_4: 'v3 → v4：',
        label2_5: 'v4 → v5：',
        label2_6: 'v5 → v6：',
        label2_7: 'v6 → v7：',
        p2_1: '直推3人，团队达到100人。',
        p2_2: '直推5人，团队达到200人。',
        p2_3: '直推5人，其中两人达到v2。',
        p2_4: '直推5人，其中两人达到v3。',
        p2_5: '直推5人，其中两人达到v4。',
        p2_6: '直推5人，其中两人达到v5。',
        p2_7: '直推5人，其中两人达到v6。',
        h2_3: '机器人发放标准：',
        label3_1: 'V1',
        label3_2: 'V2',
        label3_3: 'V3',
        label3_4: 'V4',
        label3_5: 'V5',
        label3_6: 'V6',
        label3_7: 'V7',
        p3_1: '获得1个机器人。',
        p3_2: '获得3个机器人。',
        p3_3: '获得5个机器人。',
        p3_4: '获得6个机器人。',
        p3_5: '获得7个机器人。',
        p3_6: '获得9个机器人。',
        p3_7: '获得10个机器人，并额外赠送5个，总计15个机器人。',
        h2_4: '机器人有效运行条件：',
        label4_1: '持续签到：',
        label4_2: '激活条件：',
        label4_3: '签到中断：',
        p4_1: '会员需保持每日签到，以确保机器人有效运行。',
        p4_2: '仅连续签到会员可激活打新服务。',
        p4_3: '若当日漏签，次日打新机器人将停止运行，恢复签到后次日零点自动激活。',
        h2_5: '总结：',
        p5: '本平台数字货币打新机器人模块，通过高效算法与智能策略，为会员提供自动化、高效、安全的打新服务。随着技术的不断进步，我们将持续优化用户体验，拓展更多元化的打新选择，助力会员实现资产增值。'
    },
    invite: {
        title: '邀请好友',
        info1: '邀请好友加入注册/团队',
        info2: '有机会获得开启机器人机会/推广收益',
        info3: '嗨！欢迎来到 TokenTrend 平台',
        info4: '专为币圈新手定制 全新工具一键上手',
        btn: '复制邀请链接'
    }
,
    hyperliquid: {
        searchPlaceholder: '输入钱包地址查询持仓信息...',
        searchBtn: '查询',
        title: '鲸鱼仓位监控',
        dataCount: '共 {0} 个大户持仓',
        long: '做多',
        short: '做空',
        cross: '全仓',
        isolated: '逐仓',
        positionValue: '仓位价值',
        positionSize: '仓位大小',
        entryPrice: '开仓价格',
        markPrice: '标记价格',
        unrealizedPnl: '未实现盈亏',
        noData: '暂无数据',
        enterAddress: '请输入钱包地址',
        enterValidAddress: '请输入有效的钱包地址',
        copyAddress: '复制地址',
        whale: '巨鲸',
        explorer: '浏览器',
        accountTotalValue: '账户总价值',
        perpetual: '永续合约',
        freeMarginAvailable: '可用保证金',
        withdrawable: '可提取',
        totalPositionValue: '持仓总价值',
        leverageRatio: '杠杆倍数',
        marginUsed: '已用保证金',
        usedRatio: '使用率',
        perpTotalValue: '永续持仓总价值',
        positionsCount: '{0} 个仓位',
        avgMarginUsedRatio: '平均保证金使用率',
        directionBias: '方向偏向',
        longExposure: '多头敞口',
        shortExposure: '空头敞口',
        positionDistribution: '仓位分布',
        longValue: '多头价值',
        shortValue: '空头价值',
        roe: 'ROE',
        upnl: '未实现盈亏',
        perpPositions: '永续仓位 ({0})',
        symbol: '币种',
        entryAvgPrice: '开仓均价',
        margin: '保证金',
        fundingCost: '资金费用',
        noPositions: '暂无持仓',
        userAddressRequired: '用户地址不能为空',
        addressCopied: '地址已复制',
        copyFailed: '复制失败',
        bullish: '看多',
        bearish: '看空',
        neutral: '中性'
    },
"burstHeatmapDetails": {"title":"清算热力图"},
"burstCoinStatisticsDetails": {"title":"币种清算统计"},
"forumPublish": {"title":"发布文章"},
"forumDetails": {"title":"社区文章"},
"consultDetails": {"title":"文章详情"}
}
